
export const SET_SCALES = "SET_SCALES";
export const SET_SCALE_HOUSES = "SET_SCALE_HOUSES";
export const SET_SCALE_MEASUREMENTS = "SET_SCALE_MEASUREMENTS";
export const SET_VEHICLE_CONFIGURATIONS = "SET_VEHICLE_CONFIGURATIONS";
export const SET_WEIGHING_TYPES = "SET_WEIGHING_TYPES";
